import useMiniScentDetailModel from "./useMiniScentDetailModel";
import MiniScentDetailView from "./MiniScentDetailView";

const MiniScentDetailPage = () => {
  const model = useMiniScentDetailModel();
  return <MiniScentDetailView {...model} />;
};

export default MiniScentDetailPage;
